export const PROP_MAPPINGS = {
    guid: "guid",
    data: "componentData",
    // data: "renderData",
    properties: "componentProperties",
    isLive: "live",
    isDesigner: "designer",
    newRender: "isNewRender"
};
